module.exports = __webpack_public_path__ + "media/images/athletes/2834-dbb8bf3f65fc9a430a2ad736efd1580d.png";